import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

/**
 * LoadingState Component
 *
 * A reusable loading spinner component that centers a spinner in its container.
 * Use this for inline loading states within sections or cards.
 *
 * @example
 * <LoadingState />
 */
const LoadingState = () => (
  <Flex justifyContent="center" alignItems="center" w="full" h="full" minH="400px">
    <Spinner thickness="4px" size="xl" color="brand.500" />
  </Flex>
);

export default LoadingState;
